module.exports = __webpack_public_path__ + "img/logo.778f3991.png";